import { SVGProps, Ref, forwardRef } from 'react';

export const SmartphoneFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 0C3.188 0 2.5.667 2.5 5.333v5.334C2.5 15.333 3.188 16 8 16s5.5-.667 5.5-5.333V5.333C13.5.667 12.813 0 8 0M6 4.2V2.8h4v1.4z"
                fill="currentColor"
            />
        </g>
    </svg>
));
SmartphoneFilledSize16Glyph.displayName = 'SmartphoneFilledSize16Glyph';
